import { createQueryKeys } from "@lukemorales/query-key-factory";
import { tags, type MaybeRef, type DeepMaybeRef } from "../common";
import type { ListVisitsRequest } from ".";

export const visitKeys = createQueryKeys(tags.zoolander.visits, {
  list: (filters: DeepMaybeRef<ListVisitsRequest>) => [{ filters }],
  count: (filters: DeepMaybeRef<ListVisitsRequest>) => [{ filters }],
  byId: (visitId: MaybeRef<string>) => [visitId],
});

export const visitFieldKeys = createQueryKeys(tags.zoolander.visitFields, {
  byVisitId: (visitId: MaybeRef<string>) => [visitId],
});
